export default {
  // Page metadata
  'meta.title': 'Termos de Serviço - timer.today',
  'meta.description': 'Termos de Serviço e acordo de uso para a plataforma de ferramentas de cronometragem online timer.today. Conheça nossas regras de serviço, direitos e responsabilidades do usuário.',

  // Page header
  'page.title': 'Termos de Serviço',
  'page.lastUpdated': 'Última atualização: {{date}}',
  'page.intro': 'Bem-vindo ao timer.today. Estes termos e condições descrevem as regras e regulamentos para o uso do site timer.today, localizado em timer.today.',

  // Section 1
  'section1.title': '1. Aceitação dos Termos',
  'section1.content': 'Ao acessar e usar este site, você aceita e concorda em estar vinculado aos termos e disposições deste acordo. Se você não concordar em cumprir o exposto acima, por favor não use este serviço.',

  // Section 2
  'section2.title': '2. Descrição do Serviço',
  'section2.intro': 'timer.today fornece ferramentas gratuitas de cronometragem online incluindo:',
  'section2.timer': 'Temporizador de Contagem Regressiva - Temporizador personalizável para produtividade, culinária e gestão de tempo',
  'section2.stopwatch': 'Cronômetro - Ferramenta de cronometragem de alta precisão para esportes, treinamento e cronometragem precisa',
  'section2.worldclock': 'Relógio Mundial - Exibição em tempo real de fusos horários globais',

  // Section 3
  'section3.title': '3. Licença de Uso',
  'section3.intro': 'É concedida permissão para usar temporariamente o timer.today apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título, e sob esta licença você não pode:',
  'section3.item1': 'modificar ou copiar os materiais',
  'section3.item2': 'usar os materiais para qualquer finalidade comercial ou para qualquer exibição pública',
  'section3.item3': 'tentar fazer engenharia reversa de qualquer software contido no site',
  'section3.item4': 'remover quaisquer direitos autorais ou outras notações proprietárias dos materiais',

  // Section 4
  'section4.title': '4. Privacidade e Dados',
  'section4.intro': 'timer.today está comprometido em proteger sua privacidade:',
  'section4.item1': 'Não coletamos ou armazenamos informações pessoais',
  'section4.item2': 'As configurações do temporizador são armazenadas localmente no seu navegador',
  'section4.item3': 'Não rastreamos comportamento do usuário ou padrões de uso',
  'section4.item4': 'Nenhum cookie é usado para fins de rastreamento',

  // Section 5
  'section5.title': '5. Isenção de Responsabilidade',
  'section5.content': 'Os materiais no timer.today são fornecidos "como estão". timer.today não oferece garantias, expressas ou implícitas, e por meio deste isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a uma finalidade específica ou não violação de propriedade intelectual ou outra violação de direitos.',

  // Section 6
  'section6.title': '6. Limitações',
  'section6.content': 'Em nenhum caso o timer.today ou seus fornecedores serão responsáveis por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro, ou devido à interrupção dos negócios) decorrentes do uso ou incapacidade de usar os materiais no timer.today, mesmo que o timer.today ou seu representante autorizado tenha sido notificado oralmente ou por escrito da possibilidade de tais danos.',

  // Section 7
  'section7.title': '7. Precisão dos Materiais',
  'section7.content': 'Os materiais que aparecem no timer.today podem incluir erros técnicos, tipográficos ou fotográficos. timer.today não garante que qualquer um dos materiais em seu site seja preciso, completo ou atual. timer.today pode fazer alterações nos materiais contidos em seu site a qualquer momento sem aviso prévio.',

  // Section 8
  'section8.title': '8. Modificações',
  'section8.content': 'timer.today pode revisar estes termos de serviço para seu site a qualquer momento sem aviso prévio. Ao usar este site, você concorda em estar vinculado à versão atual destes termos de serviço.',

  // Section 9
  'section9.title': '9. Informações de Contato',
  'section9.intro': 'Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco em:',
  'section9.email': 'E-mail:',
  'section9.emailSubject': 'Consulta sobre Termos de Serviço - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Todos os direitos reservados.'
};